import { render, staticRenderFns } from "./DvManageableCombo.vue?vue&type=template&id=7975069b&lang=pug"
import script from "./DvManageableCombo.vue?vue&type=script&lang=js"
export * from "./DvManageableCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports